import React from 'react';
import AcceptInvitationPage from '../components/Invitations/AcceptInvitationPage';

const AcceptInvitationPageWrapper = () => (
  <AcceptInvitationPage />
);

export default AcceptInvitationPageWrapper;

